import Pageinconu from "../../Pageinconu";

const pageerreur = () => {
    return (
        <div className="about">
            <Pageinconu />
            
        </div>
    )
}

export default pageerreur;
